import ArticleCard from "../../../../../view/components/ArticleCard/ArticleCard";
import Callout from "../../../../components/Callout/Callout";

interface ContentProps {
    posts: Array<{
        _id: string;
        title: string;
        publishedAt: string;
        mainImage: string;
        body: string;
        slug: { current: string };
        categories: Array<{ slug: { current: string }; title: string }>;
        author: string;
    }>;
    isHome?: boolean;
    title?: string;
}
export default function Content({ posts, isHome, title }: ContentProps) {
    return (
        <>
            {isHome && (
                <h3 className="text-3xl font-semibold pt-4 pb-4 border-b border-gray-200 max-w-screen-xl m-auto ">
                    {title}
                </h3>
            )}
            {posts.length > 0 &&
                posts.map((post) => (
                    <ArticleCard key={post._id} post={post} hasText={true} />
                ))}
            {posts.length == 0 && (
                <Callout>Trenutno nema objavljenih članaka.</Callout>
            )}
        </>
    );
}
